import * as XLSX from "xlsx-js-style";

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const HEADERS = [
  "Vendedor", "Bodega", "Cédula", "Nombre Completo", "Teléfono", "N° Solicitud",
  "Fecha", "Estado", "Verificación Documental", "Verificación Telefónica",
];

// Estilos compartidos por referencia entre todas las celdas del mismo tipo:
// con datasets grandes (export "todos los créditos"), crear un objeto de
// estilo nuevo por celda multiplica el uso de memoria y puede tumbar el
// proceso por out-of-memory. xlsx-js-style solo serializa lo que referencia
// cada celda, así que reusar la misma referencia es seguro.
const BORDER = {
  top: { style: "thin", color: { auto: 1 } },
  bottom: { style: "thin", color: { auto: 1 } },
  left: { style: "thin", color: { auto: 1 } },
  right: { style: "thin", color: { auto: 1 } },
};
const CENTER_STYLE = { alignment: { vertical: "center", horizontal: "center" }, border: BORDER };
const LEFT_STYLE   = { alignment: { vertical: "center", horizontal: "left" },   border: BORDER };
const HEADER_STYLE = {
  alignment: { vertical: "center", horizontal: "center" },
  border: BORDER,
  font: { bold: true, color: { rgb: "FFFFFF" } },
  fill: { fgColor: { rgb: "2D3689" } },
};
const ESTADO_STYLE = {
  'PRE-APROBADO': { alignment: CENTER_STYLE.alignment, border: BORDER, fill: { fgColor: { rgb: "FEF3C7" } }, font: { bold: true, color: { rgb: "92400E" } } },
  'APROBADO':     { alignment: CENTER_STYLE.alignment, border: BORDER, fill: { fgColor: { rgb: "D1FAE5" } }, font: { bold: true, color: { rgb: "065F46" } } },
};

// Exporta la lista de créditos aprobados/pre-aprobados a Excel. Sirve para los
// 3 alcances (vendedor / bodega / todos) sin distinción: el SP siempre trae
// NombreVendedor y NombreBodega, sin importar qué filtro se haya aplicado.
//
// `opciones.estilos` (default true) aplica color/bordes celda por celda —
// para el export de TODAS las bodegas el dataset puede ser de decenas de
// miles de filas, y decorar cada celda individual (aun reutilizando objetos
// de estilo) es memoria de más que puede tumbar el proceso; ese caller pasa
// estilos: false para generar un .xlsx plano sin recorrer celda por celda.
export function exportarClientesAprobadosExcel(rows, titulo, opciones = {}) {
  const { estilos = true } = opciones;
  if (!rows || rows.length === 0) return;

  const ws_data = [HEADERS];
  rows.forEach(row => {
    ws_data.push([
      row.NombreVendedor || '—',
      row.NombreBodega || '—',
      row.Cedula || '—',
      row.NombreCompleto || '—',
      row.Celular || '—',
      row.NumeroSolicitud || '—',
      formatDate(row.Fecha),
      row.Estado || '—',
      row.VerificacionDocumental || '—',
      row.VerificacionTelefonica || '—',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(ws_data);

  if (estilos) {
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
        const cell = ws[cell_ref];
        if (!cell) continue;

        if (R === 0) {
          cell.s = HEADER_STYLE;
        } else if (C === 7) {
          cell.s = ESTADO_STYLE[cell.v] || CENTER_STYLE;
        } else {
          cell.s = C === 3 ? LEFT_STYLE : CENTER_STYLE;
        }
      }
    }
  } else {
    HEADERS.forEach((_, C) => {
      const cell_ref = XLSX.utils.encode_cell({ c: C, r: 0 });
      if (ws[cell_ref]) ws[cell_ref].s = HEADER_STYLE;
    });
  }

  ws['!cols'] = [
    { wch: 26 }, { wch: 22 }, { wch: 14 }, { wch: 32 }, { wch: 14 }, { wch: 14 },
    { wch: 12 }, { wch: 14 }, { wch: 22 }, { wch: 22 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Clientes Aprobados");
  XLSX.writeFile(wb, `${titulo}.xlsx`);
}
